<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md12
      >

      

        <v-dialog
          v-model="dialog"
          width="1000"
          hegiht="auto"
        >
          <template v-slot:activator="{ on }">
            
                <v-flex
                  xs12
                  md4
                >
            <v-btn
              color="success"
              dark
              v-on="on"
            >
              Create New Exam cuck
            </v-btn>



                <download-excel v-if="excelData.length"
                  class="btn btn-primary"
                  :data="excelData"
                  :fields="excelHeaders"
                  worksheet = "My Worksheet"
                  :name="subject.name +' Lectures Medical.xls'">
                </download-excel>


            
                </v-flex>
          </template>

          <v-card>
        
                <Form
              :Item="item"
              :Field="inputFields"
              :Value="valueObj"
              @emitted="getBackData"
              />


          </v-card>
        </v-dialog>
        <material-card
        
          color="green"
          title="Exam List"
          text=""
        >

          <v-data-table
            :headers="headers"
            :items="examList"
            
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td>{{ item.exam_name }}</td>
              <td>{{ item.duration }}</td>
              <td>{{ item.total_mark }}</td>
            </template>
          </v-data-table>
        </material-card>
        
       
        <v-snackbar
          :color="color"
          :bottom="bottom"
          :top="top"
          :left="left"
          :right="right"
          v-model="snackbar"
          dark
        >
          <v-icon color="white" class="mr-3">mdi-bell-plus</v-icon>
          <div>{{ noticeMessage }}</div>
          <v-icon size="16" @click="snackbar = false">mdi-close-circle</v-icon>
        </v-snackbar>

      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Form from '@/views/Form'
export default {
  components: {
    Form,
  },
  computed: {
    // ...mapGetters("subject_details", ["examList"]),
    ...mapState('subject_details', ['examList']),
  },
  mounted () {
    this.getExamListBySubject(this.valueObj)
  },
  data () {
    return {
    color: null,
    colors: [
      'warning'
    ],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
      
    headers: [
      {
        sortable: true,
        text: 'Title',
        value: 'name'
      },
      {
        sortable: false,
        text: 'Duration',
        value: 'duration'
      },
      {
        sortable: true,
        text: 'Marks',
        value: 'total_mark'
      },
    ],
      dialog: false,
      dialogScript: false,
      noticeMessage: '',
      item: {
        'title': 'New Exam',
        'subTitle': 'This exam will be uploaded as unpulished. ',
        'width': 'md6',
        'submitText' : 'Submit'
      },
      valueObj: {
        'course_id' : this.$route.params.courseId,
        'subject_id' : this.$route.params.subjectId
       },
       
      inputFields: [
        {
          label: 'Exam Name',
          type: 'text',
          isEnable: true,
          name: 'exam_name',
          formName: 'Exam name',
          nameRules: [
            v => !!v || 'Exam name is required',
            v => (v && v.length <= 150) || 'Exam name must be less than 150 characters'
          ]
        },
        {
          label: 'Duration',
          type: 'number',
          isEnable: true,
          name: 'duration',
          formName: 'duration',
           nameRules: [
            v => !!v || 'Duration is required',
          ]
        },
        {
          label: 'Total mark',
          type: 'number',
          isEnable: true,
          name: 'total_mark',
          formName: 'Total mark',
           nameRules: [
            v => !!v || 'Total mark is required',
          ]
        },
        {
          label: 'Number of questions',
          type: 'number',
          isEnable: true,
          name: 'question_number',
          formName: 'Question number',
           nameRules: [
            v => !!v || 'Question number is required',
          ]
        },
        {
          label: 'Positive mark',
          type: 'number',
          isEnable: true,
          name: 'positive_mark',
          formName: 'Positive mark',
           nameRules: []
        },
        {
          label: 'Negative mark',
          type: 'number',
          isEnable: true,
          name: 'negative_mark',
          formName: 'Negative mark',
           nameRules: []
        }
      ],
      
        excelHeaders: {
          "#": 'count',
          "Chapter Name": 'chapeter_name',
          "Lecter name": 'lecture_name'
        },
        excelData: [],
        subject : null
    }

  },
  created () {
    this.getExcelData()
  },

  methods: {
    ...mapActions("subject_details", ["storeSubjectExam","getExamListBySubject", "getChapterNameListBySubjectId"]),
 
    async getExcelData () {
      let data = []
      
      const response = await this.getChapterNameListBySubjectId('course/getChapterNameListBySubjectId/'+ this.$route.params.courseId +'/' + this.$route.params.subjectId)
      this.subject = response.subject
      let chapters = response.chapters
      let count = 1
        chapters.forEach(item => {
          let lectures = item.lecture_videos
          lectures.forEach((element,i) => {
            data.push(
              {
                'count':  count++,
                'chapeter_name': i === 0 ? item.name : null,
                'lecture_name': element.title
              }
            )
          })
          
        })
      console.log(data)
        this.excelData = data
    },
    getBackData (data) {
      data.status = "unpublished"
      this.storeSubjectExam(data).then((response) => {
        if (response.status == 'OK') {
        this.getExamListBySubject(this.valueObj)
          this.dialog = false
          this.color = "success";
          this.noticeMessage = "Success! " + response.messages;
          this.snack("top");
        } else {
          this.noticeMessage = response.messages
          this.snack('top')
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false

      for (const loc of args) {
        this[loc] = true
      }
      this.snackbar = true
    }
  }
}
</script>
